export default [
  {
    path: '/sobre',
    name: 'about',
    meta: {
      authorize: [],
      breadcrumb: 'Sobre'
    },
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/About.vue')
  },
]
